import { Button } from "antd";
import { TrashSvg } from "components/Icon";

const MediActionDelete = (props) => {
  const handleClick = (e) => {
    if (props.onClick) {
      props.onClick(e);
    }
  };

  return (
    <Button {...props} icon={<TrashSvg />} onClick={handleClick} type="text">
      {props.children}
    </Button>
  );
};

export default MediActionDelete;
